import { cloneElement, useRef } from 'react';
import { useOverlayTrigger } from 'react-aria';
import { useOverlayTriggerState } from 'react-stately';
import PopoverButton from 'client/components/aria/Popover/PopoverButton/PopoverButton';
import PopoverOverlay from 'client/components/aria/Popover/PopoverOverlay/PopoverOverlay';

const PopoverTrigger = ({ label, children, ...props }) => {
    const ref = useRef();
    const state = useOverlayTriggerState(props);
    const { triggerProps, overlayProps } = useOverlayTrigger(
        { type: 'dialog' },
        state,
        ref
    );

    const { isOpen } = state;
    return (
        <>
            <PopoverButton
                data-testid={props['data-testid'] ? props['data-testid'] : null}
                {...triggerProps}
                aria-label={props['aria-label']}
                buttonRef={ref}
                isOpen={isOpen}
            >
                {label}
            </PopoverButton>
            {isOpen &&
                (
                    <PopoverOverlay {...props} triggerRef={ref} state={state}>
                        {cloneElement(children, overlayProps)}
                    </PopoverOverlay>
                )}
        </>
    );
};

export default PopoverTrigger;
